module.exports = __webpack_public_path__ + "gs.1067356806f9346264da.svg";


//////////////////
// WEBPACK FOOTER
// C:/Angular/projetos/RetycargasOfficialSite/src/assets/vendor/flag-icon-css-master/flags/1x1/gs.svg
// module id = ../../../../../src/assets/vendor/flag-icon-css-master/flags/1x1/gs.svg
// module chunks = styles